import { TransferSacRequest } from 'domain/usecases/sacRequest/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteTransferSacRequest implements TransferSacRequest {
  private readonly url: string;

  private readonly httpClient: HttpClient<TransferSacRequest.Model>;

  constructor(url: string, httClient: HttpClient<TransferSacRequest.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  transfer = async (
    params: TransferSacRequest.Params,
  ): Promise<TransferSacRequest.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{request}', params.request.toString()),
      body: params.body,
      method: 'post',
      headers: params?.token
        ? {
            Authorization: `Bearer ${params?.token || undefined}`,
          }
        : undefined,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
